<template>
    <filters-wrapper
        :has-active-filters="props.hasActiveFilters"
        :is-expanded="props.locationType === 'city'"
        @submit="emit('submit')"
        @reset="emit('reset')"
    >
        <template v-if="props.locationType === 'location_point' || props.locationType === 'venue'" v-slot:panel>
            <FilterStatusToggle v-model="filters.active" @update:model-value="emit('submit')" />
        </template>
        <v-form class="mb-5 table-filters">
            <v-row dense align="center">
                <v-col
                    v-if="props.locationType === 'location_point' || props.locationType === 'venue'"
                    cols="12"
                    lg="2"
                    md="3"
                    sm="6"
                >
                    <v-text-field
                        v-model="filters.name"
                        :label="$t('name')"
                        density="compact"
                        variant="outlined"
                        color="primary"
                        hide-details
                        data-cy="name"
                    />
                </v-col>
                <v-col v-if="props.locationType !== 'venue'" cols="12" lg="2" md="3" sm="6">
                    <country-autocomplete
                        v-model="filters.country"
                        :label="$t('country')"
                        dense
                        class="input--no-arrows"
                    />
                </v-col>
                <v-col
                    v-if="props.locationType === 'location_point' || props.locationType === 'venue'"
                    cols="12"
                    lg="2"
                    md="3"
                    sm="6"
                >
                    <city-autocomplete v-model="filters.city" :label="$t('city')" dense class="input--no-arrows" />
                </v-col>
            </v-row>
        </v-form>
    </filters-wrapper>
</template>

<script setup lang="ts">
    import {initLocationsFilters} from '~/utils/types/account/locations/helpers'
    import type {LocationsFiltersType} from '~/utils/types/account/locations/types'
    import CountryAutocomplete from '~/components/search/forms/CountryAutocomplete.vue'
    import CityAutocomplete from '~/components/search/forms/CityAutocomplete.vue'

    const props = defineProps<{
        hasActiveFilters: boolean
        locationType: string
    }>()
    const filters = defineModel<LocationsFiltersType>({
        default: initLocationsFilters(),
    })
    const emit = defineEmits<{
        (e: 'submit' | 'reset'): void
    }>()
</script>
